module.exports = __webpack_public_path__ + "img/password_close_icon.7bf0c435.svg";